import React from 'react'
import InfoPanel from 'components/generic/InfoPanel'
import { ReactComponent as IconScores } from 'images/icons/icn_large_score.svg'
interface Props {
  title?: string
  info?: string
  className?: string
}

const NoScoresPanel = ({ title, info, className = '' }: Props) => {
  return <InfoPanel icon={<IconScores />} title={title} info={info} className={className} />
}

export default NoScoresPanel
